<template>
	<div>
		<list-renderer :apiUrl="'/api/' + $selectedSite.slug + '/seos'" :filterIn="['key','preview']" :listInData="'allSeo'" :orderBy="orderBy" :orderByRules="orderByRules" :additionalFilters="additionalFilters">
			<template #header>
				<h2>Seo</h2>
				<div class="ml-auto">
					<a href="#" class="btn btn-md btn-success" @click.prevent="seoModal(null)"><i class="fas fa-plus"></i> New Seo</a>
				</div>
			</template>
			<template #content='{list, rawData}'>
				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th>Key</th>
								<th>Preview</th>
								<th>Group</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="seo in list">
								<td>{{ seo.key }}</td>
								<td>{{ seo.preview }}</td>
								<td>{{ seo.scope }}</td>
								<td class="nowrap">
									<a class="btn btn-icon btn-primary" href="#" title="Edit" @click.prevent="seoModal(seo)"><i class="fas fa-pencil-alt"></i></a>
									<a class="btn btn-icon btn-danger" href="#" title="Delete" @click.prevent="deleteSeo(seo.id)"><i class="fas fa-trash-alt"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>
		<seo-editor
				:meta-config="metaConfig"
		></seo-editor>
	</div>
</template>

<script>
import SeoEditor from "./SeoEditor.vue";
import {eventBus} from "../../app";

export default {
	name: "Seo",
	components: {SeoEditor},
	props: {
		metaConfig: {
			required: true
		}
	},
	data() {
		return {
			orderBy: ['preview'],
			orderByRules: ['desc', 'asc'],
			additionalFilters: {
				Groups: {
					elements: this.metaConfig['groups'],
					elementsValue: null,
					elementsLabel: null,
					width: 2,
					filterIn: 'scope',
					default: null,
					orderBy: ['group'],
					orderByRules: ['asc'],
				}
			},
		}
	},
	methods: {
		seoModal: function (seo) {
			eventBus.$emit('onSeoModalOpen', seo);
		},
		deleteSeo: function (id) {
			let vm = this;
			vm.$dialog.confirm('Are you sure you want to delete this seo?')
					.then(function (dialog) {
						axios.delete('/api/' + vm.$selectedSite.slug + '/seos/' + id)
								.then(function(response) {
									vm.$toastr.success('Seo deleted.');
									window.location.reload();
								})
								.catch(function(e) {
									vm.$toastr.error('Seo category failed.', 'Error');
								})
					})
					.catch(function (error) {
						vm.$toastr.error('Delete aborted.');
					});
		}
	}
}
</script>

<style scoped>

</style>
